import { Component, Input } from '@angular/core';
import { AppStreamEnvironment } from '../../api/erm-capability/models/AppStreamEnvironment';

@Component({
  standalone: false,
  selector: 'lib-env-labels',
  templateUrl: './env-labels.component.html',
  styleUrls: ['./env-labels.component.scss']
})
export class EnvironmentLabelsComponent {
  @Input() env?: AppStreamEnvironment;
}
